import { CurrentSoundRef, HumanoidRef } from '@3d-lib/types';
import React, { ReactNode, createContext, useContext } from 'react';

type GameContext = {
  humanoidRef: HumanoidRef;
  currentSoundRef: CurrentSoundRef;
};

const defaultGameContext: GameContext = {
  humanoidRef: { current: null },
  currentSoundRef: { current: null },
};

const GameContextContext = createContext<GameContext>(defaultGameContext);

const useGameContext = () => {
  return useContext(GameContextContext);
};

interface GameContextProviderProps {
  children: ReactNode;
  humanoidRef: HumanoidRef;
  currentSoundRef: CurrentSoundRef;
}

const GameContextProvider: React.FC<GameContextProviderProps> = ({
  children,
  humanoidRef,
  currentSoundRef,
}) => {
  return (
    <GameContextContext.Provider value={{ humanoidRef, currentSoundRef }}>
      {children}
    </GameContextContext.Provider>
  );
};

export { GameContextProvider, useGameContext };
